<template>
	<v-card style="border-radius: 15px">
		<v-layout row justify-center>
			<div key="relatorio_title" class="title pa-2 text-xs-center">
				{{ strings[idioma].relatorio_financeiro }}

				<v-menu
					:close-on-content-click="false"
					v-model="menu"
					color
					fixed
					bottom
				>
					<template v-slot:activator="{ on }">
						<v-btn
							class="mx-2"
							icon
							small
							:title="strings[idioma].dados_financeiro"
							v-on="on"
						>
							<v-icon>mdi-information-outline</v-icon>
						</v-btn>
					</template>
				</v-menu>
				<template v-if="menu">
					<v-card>
						<div style="width: 80%; text-align: center; margin: auto">
							<p
								style="
									display: block;
									text-align: justify;
									text-justify: inter-word;
									margin: 10px;
									color: rgb(78, 78, 78);
									font-size: 20px;
								"
							>
								{{ strings[idioma].info_financeiro }}
							</p>
						</div>
					</v-card>
				</template>
			</div>
		</v-layout>
		<v-data-table
			ref="dTableRelatorioFinanceiro"
			:items="headersRelatorioFinanceiro"
			item-key="id"
			hide-actions
			hide-headers
			class="elevation-1 table-exigencias table-relatorio"
		>
			<template v-slot:items="props">
				<tr style="background-color: #ababab">
					<td
						style="text-align: center"
						@click="props.expanded = !props.expanded"
					>
						<v-icon :color="props.expanded ? 'black' : 'black'">{{
							props.expanded ? "mdi-chevron-down" : "mdi-chevron-right"
						}}</v-icon>

						<strong style="font-size: 18px">{{
							props.item.title[idioma]
						}}</strong>
					</td>
				</tr>
			</template>
			<template v-slot:expand="props">
				<v-card
					v-if="Object.keys(relatorio_financeiro[props.item.id]).length"
					flat
				>
					<v-layout row wrap pr-1 pl-1 pt-2 pb-3>
						<v-flex xs12>
							<v-data-table
								show-expand
								:items="
									Object.values(relatorio_financeiro[props.item.id]).filter(
										(item) =>
											item.livre ||
											getAcessoModulo({
												user: user,
												modulo: RELATORIO_FINANCEIRO_COMPLETO,
											})
									)
								"
								class="elevation-1 table-exigencias table-relatorio border-table-child"
								item-key="id"
								hide-actions
								hide-headers
							>
								<template v-slot:items="propsSubTopico">
									<tr
										@click="
											propsSubTopico.item.expanded =
												!propsSubTopico.item.expanded
										"
									>
										<td>
											<strong>{{ propsSubTopico.item.title[idioma] }}</strong>
										</td>
										<td style="width: 40%">
											<v-text-field
												v-money="
													renderMask(
														propsSubTopico.item.unidadeEsq
															? propsSubTopico.item.unidadeEsq
															: ['', '', ''],
														propsSubTopico.item.unidadeDir
															? propsSubTopico.item.unidadeDir
															: ['', '', ''],
														idioma
													)
												"
												v-if="!propsSubTopico.item.inteiro"
												:value="
													parseFloat(propsSubTopico.item.valor).toFixed(2)
												"
												readonly
												class="text-field-table input-disabled"
												color="primary"
												outline
											/>
											<v-text-field
												v-money="optionsNumber.int[idioma]"
												v-else
												:value="
													parseFloat(propsSubTopico.item.valor).toFixed(0)
												"
												readonly
												class="text-field-table input-disabled"
												color="primary"
												outline
											/>
										</td>
									</tr>
								</template>
							</v-data-table>
						</v-flex>
					</v-layout>
				</v-card>
			</template>
		</v-data-table>
	</v-card>
</template>
<script>
import { mapState } from "vuex";
import { VMoney } from "v-money";
import { RELATORIO_FINANCEIRO_COMPLETO } from "@/utils/types.js";
import { getAcessoModulo } from "@/store/auth/actions";
export default {
	directives: {
		money: VMoney,
	},
	data: () => ({
		RELATORIO_FINANCEIRO_COMPLETO: RELATORIO_FINANCEIRO_COMPLETO,
		menu: false,
	}),
	computed: {
		...mapState("app", [
			"relatorio_financeiro",
			"headersExigenciasRelatorio",
			"headersRelatorioFinanceiro",
			"optionsNumber",
			"idioma",
			"strings",
			"user",
		]),
	},
	mounted() {
		this.headersRelatorioFinanceiro.forEach((el) => {
			this.$set(this.$refs.dTableRelatorioFinanceiro.expanded, el.id, true);
		});
	},
	methods: {
		getAcessoModulo({ user, modulo }) {
			let res = getAcessoModulo(this.$store, { user, modulo });
			return res;
		},
		renderMask(esq, dir, idioma) {
			return {
				decimal: idioma === 0 || idioma === 2 ? "," : ".",
				thousands: idioma === 0 || idioma === 2 ? "." : ",",
				precision: 2,
				prefix: esq[idioma] + " ",
				suffix: " " + dir[idioma],
			};
		},
	},
};
</script>
